import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { defaultDataAcessor } from 'src/app/core/helpers/mat-sort-data-accessor';
import { IAtividadeTipoTrabalhoModel } from 'src/app/models/atividade-tipo-trabalho.model';
import { EnumAcaoRecurso } from 'src/app/models/enum/acao-recurso.enum';
import { EnumRecursoPerfil } from 'src/app/models/enum/recurso-perfil.enum';
import { FiltroPapeisTrabalho } from 'src/app/models/filtro-papeis-trabalho';
import { FiltroModel } from 'src/app/models/filtro.model';
import { IPapeisTrabalhoModel } from 'src/app/models/papeis-trabalho-model';
import { IPermissaoModel } from 'src/app/models/permissao.model';
import { AtividadeTipoTrabalhoService } from 'src/app/services/atividade-tipo-trabalho.service';
import { AuthService } from 'src/app/services/auth.service';
import { FaseAtividadeService } from 'src/app/services/fase-atividade.service';
import { PapeisTrabalhoService } from 'src/app/services/papeis-trabalho.service';
import { TipoTrabalhoService } from 'src/app/services/tipo-trabalho.service';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-papeis-trabalho-list',
  templateUrl: './papeis-trabalho-list.component.html',
  styleUrls: ['./papeis-trabalho-list.component.scss']
})
export class PapeisTrabalhoListComponent extends BaseListComponent {
  public dataSource = new MatTableDataSource<IPapeisTrabalhoModel>([]);
  public displayedColumns: string[] = ['selecao', 'nome', 'tipoNome', 'faseNome', 'situacaoNome', 'ativo'];
  public selectedModel: IPapeisTrabalhoModel;
  public searchNome: string;
  public searchAtivo = true;
  public semDados = true;
  public permissoes: IPermissaoModel;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public searchSituacao: number;
  public searchTipo: number;
  public searchFase: number;
  public searchPapel: number;

  public filtro = {} as FiltroPapeisTrabalho;
  listTipoTrabalho: any[] = [];
  listFases: any[] = [];
  listTodasFases: any[] = [];

  constructor(
    private papeisTrabalhoService: PapeisTrabalhoService,
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService,
    private faseAtividadesService: FaseAtividadeService,
    private tipoTrabalhoService: TipoTrabalhoService,
    private atividadeTipoTrabalhoService: AtividadeTipoTrabalhoService,
    )
     {
      super();
      this.buscar();
    }

    ngOnInit(): void {
      this.carregaFases();
      this.carregaTiposTrabalho();

      this.setarPermissoes();
    }
  
    private setarPermissoes(): void {
      this.permissoes = new IPermissaoModel();
      this.permissoes.consultar = this.authService.possuiPermissao(EnumRecursoPerfil.CadastroPapeisTrabalho, EnumAcaoRecurso.Consultar);
      this.permissoes.editar = this.authService.possuiPermissao(EnumRecursoPerfil.CadastroPapeisTrabalho, EnumAcaoRecurso.Editar);
      this.permissoes.excluir = this.authService.possuiPermissao(EnumRecursoPerfil.CadastroPapeisTrabalho, EnumAcaoRecurso.Excluir);
      this.permissoes.inativarReativar = this.authService.possuiPermissao(EnumRecursoPerfil.CadastroPapeisTrabalho, EnumAcaoRecurso.AtivarInativar);
      this.permissoes.incluir = this.authService.possuiPermissao(EnumRecursoPerfil.CadastroPapeisTrabalho, EnumAcaoRecurso.Inserir);
      this.permissoes.visualizar = this.authService.possuiPermissao(EnumRecursoPerfil.CadastroPapeisTrabalho, EnumAcaoRecurso.Visualizar);
   }

  public buscar() {
    this.configurarFiltro();
    
    this.selectedModel = null;

    this.papeisTrabalhoService
      .obter(this.filtro)
      .then((res) => {
        this.dataSource = new MatTableDataSource<IPapeisTrabalhoModel>(res.dados);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.dataSource.sortingDataAccessor = defaultDataAcessor;
        this.dataSource._updateChangeSubscription();
        this.semDados = this.dataSource.filteredData.length === 0;
      })
      .catch((err) => {
        this.exibirMensagemAlerta(err.mensagem.descricao);
      })
  }

  private configurarFiltro() {
    this.filtro.pesquisa = this.searchNome == undefined ? '' : this.searchNome;
    this.filtro.idFase = this.searchFase == undefined ? 0 : this.searchFase;
    this.filtro.idPapelAceitavel = this.searchPapel == undefined ? 0 : this.searchPapel;
    this.filtro.idSituacao = this.searchSituacao == undefined ? 0 : this.searchSituacao;
    this.filtro.idTipo = this.searchTipo == undefined ? 0 : this.searchTipo;
    this.filtro.ativo = this.searchAtivo == undefined ? undefined : this.searchAtivo;
  }

  public reativar(id: number) {
        this.papeisTrabalhoService
        .reativar(id)
        .then((res) => {
          if (res.sucesso) {
            Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'success',
              text: 'Papéis de Trabalho reativado com sucesso.',
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
            });
          } else {
            this.exibirMensagemAlerta(res.mensagem.descricao);
          }
        })
        .catch((err) => {
          this.exibirMensagemErro(err.mensagem.descricao);
        })
        .finally(() => {
          this.buscar();
        });
  }

  public inativar(id: number) {
    this.papeisTrabalhoService
    .inativar(id)
    .then((res) => {
      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          text: 'Papéis de Trabalho inativado com sucesso.',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      } else {
        this.exibirMensagemAlerta(res.mensagem.descricao);
      }
    })
    .catch((err) => {
      this.exibirMensagemErro(err.mensagem.descricao);
    })
    .finally(() => {
      this.buscar();
    });
  }

  public editar(id: number) {
    this.router.navigate([`/papeis-trabalho/${id}`]);
  }

  public novo() {
    this.router.navigate(['/papeis-trabalho/novo']);
  }

  public excluir(id: number) {
    this.papeisTrabalhoService
    .excluir(id)
    .then((res) => {
      this.exibirMensagemAlerta(res.mensagem.descricao);
    })
    .catch((err) => {
      this.exibirMensagemErro(err.mensagem.descricao);
    })
    .finally(() => {
      this.buscar();
    });
  }

  public visualizar(id: number) {
    this.router.navigate([`/papeis-trabalho/${id}/visualizar`]);
  }

  public selecionar(item: any) {
    this.selectedModel = !this.selectedModel || this.selectedModel.id !== item.id ? item : null;
  }

  changeTipo(idTipo: number) {
    this.listFases = [];    
    if (this.listTodasFases != null && this.listTodasFases.length > 0) {
      let tipo = this.listTodasFases.find(f => f.tipoTrabalho.id == idTipo);
      if (tipo != null && tipo.fases != null && tipo.fases.length > 0) {
        this.listFases = tipo.fases;
      }        
    }
  }

  async carregaFases() {
    let filtro = {} as FiltroModel;
    filtro.ativo = true;
    const res = await this.atividadeTipoTrabalhoService.obterTodos(filtro);
    if (res.sucesso) {
      this.listTodasFases = res.dados as IAtividadeTipoTrabalhoModel[];          
    }
  }

  async carregaTiposTrabalho() {
    const res = await this.tipoTrabalhoService.obter();
    if (res.sucesso) {
      console.log(res.dados);
      this.listTipoTrabalho = res.dados;      
    }
  }

}
